import React, {FC} from 'react';
import {PostFooter} from './PostFooter';

const style = {
	admin: `flex flex-row basis-1/2   pt-1`,
	container: `flex flex-col gap-y-2   p-4   text-whirlwindLightest   bg-whirlwindDarkest   divide-y-4 divide-whirlwindDark   rounded-md   opacity-90`,
	deleteButton: `text-whirlwindRed hover:text-whirlwindRedDark   opacity-90`,
	footer: `flex flex-row   pt-1`,
	header: `flex flex-row justify-end items-center`,
	post: `pt-1   break-words`,
	time: `basis-1/2   pt-1   text-xs text-right`,
	username: `text-lg font-semibold text-whirlwindPrimaryLight`,
};

type PostProps = {
	content: string;
	created_at: string;
	dataTestContent: string;
	documentId: string;
	uid: string;
	username: string;
};

export const Post: FC<PostProps> = ({
	content,
	created_at,
	dataTestContent,
	documentId,
	uid,
	username,
}) => {
	return (
		<div className={style.container} data-test-content={dataTestContent}>
			<div className={style.header}>
				<span className={style.username}>{username}</span>
			</div>
			<div className={style.post}>
				<span>{content}</span>
			</div>
			<PostFooter
				created_at={created_at}
				documentId={documentId}
				uid={uid}
			/>
		</div>
	);
};
